import React from 'react';
import {Table} from '..';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  {
    id: 'customer',
    numeric: false,
    disabledPadding: true,
    label: 'Customer',
  },
  {
    id: 'paid',
    numeric: false,
    disabledPadding: false,
    label: 'Paid',
  },
  {
    id: 'note',
    numeric: false,
    disabledPadding: false,
    label: 'Note',
  },
  {
    id: 'fromDate',
    numeric: false,
    disabledPadding: false,
    label: 'From date',
  },
  {
    id: 'toDate',
    numeric: false,
    disabledPadding: false,
    label: 'To date',
  },
  {
    id: 'building',
    numeric: false,
    disabledPadding: false,
    label: 'Building',
  },
  {
    id: 'entrance',
    numeric: false,
    disabledPadding: false,
    label: 'Entrance',
  },
  {
    id: 'createdBy',
    numeric: false,
    disabledPadding: false,
    label: 'Created by',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

const DATA_CELLS = [
  'customer',
  'paid',
  'note',
  'fromDate',
  'toDate',
  'building',
  'entrance',
  'createdBy',
  'createdAt',
];

const PaymentsReportTable = ({payments, loading}) => {
  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={payments}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
      noToolbar
    />
  );
};

export default PaymentsReportTable;
